import { api } from "@/api/api";

export const Common = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async uploadImage(_, file) {
            try {
                const formData = new FormData();
                formData.append("image", file);
                const response = await api.common.uploadImage(formData);

                return response;
            } catch (error) {
                console.error("upload err:" + error);
                throw new Error("Upload error");
            }
        },

        async uploadFile(_, file) {
            try {
                const formData = new FormData();
                formData.append("file", file);
                const response = await api.common.uploadFile(formData);

                return response;
            } catch (error) {
                console.error("upload err:" + error);
                throw new Error("Upload error");
            }
        },
    },
};
